var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-menu-item",class:{active: _vm.active},attrs:{"tabindex":"-1"},on:{"click":_vm.click}},[_c('div',{staticClass:"flex-grow"},[_vm._t("default")],2),_c('icon',{staticClass:"ml-4 opacity-0 w-6 flex-shrink-0",class:{
        'opacity-100': _vm.active,
    },attrs:{"name":"check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }